"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doMove = doMove;
const board_1 = require("@creature-chess/board");
const getCooldownForSpeed_1 = require("../../../utils/getCooldownForSpeed");
const getStats_1 = require("../../../utils/getStats");
const MOVE_TURN_DURATION = 2;
function doMove(currentTurn, board, pieceRegistry, id, action, { combatStore, creatures }) {
    const existingPosition = board.getPiecePosition(id);
    if (!existingPosition) {
        return;
    }
    const combatState = combatStore.getPiece(id);
    // if the piece can't move yet, don't do anything
    if ((combatState.canMoveAtTurn || 0) > currentTurn) {
        return;
    }
    const piece = pieceRegistry.getPieceById(id);
    if (!piece) {
        return;
    }
    const stats = (0, getStats_1.getStats)(piece, creatures);
    const canMoveAtTurn = currentTurn + MOVE_TURN_DURATION + (0, getCooldownForSpeed_1.getCooldownForSpeed)(stats.speed);
    combatStore.updatePiecePartial(piece.id, {
        canMoveAtTurn,
    });
    board.setPiece(id, (0, board_1.unpackX)(action.payload), (0, board_1.unpackY)(action.payload));
}
